import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import VueRouter from 'vue-router'
import { getInstance } from '../auth/authWrapper'
import { isChatSectionPath, trackMultichatExit } from '@/helpers/gcb2/multichatAnalytics'
import { hasYClientsConnector } from '@/helpers/gcb2/yclientsOnly'
const Landing = () => import('../views/Landing.vue')
//import Tariff from '../views/Tariff.vue'
const Marketplace = () => import('@/modules/marketplace/views/Marketplace.vue')
const Integration = () => import('@/modules/marketplace/views/Integration.vue')
const Projects = () => import('../views/Projects.vue')
const Project = () => import('../views/Project.vue')
const ProjectSettings = () => import('@/views/ProjectSettings.vue')
const RolesSettings = () => import('@/views/RolesSettings.vue')
const NotFound = () => import('../views/NotFound.vue')
const OAuthLogin = () => import('../views/OAuthLogin.vue')
const ConnectorSettings = () => import('../views/ConnectorSettings.vue')
const AddConnectorStage1 = () => import('../views/AddConnectorStage1.vue')
const AddConnectorStage2 = () => import('../views/AddConnectorStage2.vue')
const AddConnectorStage3 = () => import('../views/AddConnectorStage3.vue')
const AddChannelStage1 = () => import('../views/AddChannelStage1.vue')
const AddChannelStage2 = () => import('../views/AddChannelStage2.vue')
const AddChannelStage3 = () => import('../views/AddChannelStage3.vue')
const ScheduledReport = () => import('../views/ScheduledReport.vue')
const SelectCRMSystemView = () => import('@/components/project/onBoarding/SelectCRMSystemView.vue')
const AuthorizationInCRMSystemView = () =>
    import('@/components/project/onBoarding/AuthorizationInCRMSystemView.vue')
const SettingsCRMView = () => import('@/components/project/onBoarding/SettingsCRMView.vue')
const AuthorizationPending = () => import('@/components/project/onBoarding/AuthorizationPending.vue')
const OtherConnector = () => import('@/components/project/onBoarding/OtherConnector.vue')
const BotSettingsView = () => import('@/components/project/onBoarding/BotSettingsView.vue')
const SuccessfulView = () => import('@/components/project/onBoarding/SuccessfullView.vue')
const OnBoarding = () => import('@/components/project/onBoarding/OnBoarding.vue')

import qs from 'query-string'
import GCB2Routes from './routes/GCB2.js'
import adminRoutes from './routes/admin'
import externalMarketplaceModuleRoutes from '@/modules/externalMarketplace/routes'
import adminReportPseudActivationReportRoutes from '@/modules/AdminReportPseudoActivation/routes'
import staffTurnoverRoutes from '@/modules/StaffTurnover/routes'
import staffTrajectoryRoutes from '@/modules/StaffTrajectory/routes'
import marketplaceModuleRoutes from '@/modules/marketplace/routes'
import beautyAutopilotRoutes from '@/modules/BeautyAutopilot/routes'
import starterPackRoutes from '@/modules/StarterPack/routes'
import { checkRole } from '../helpers/roles'
import store from '../store'
import {
    resolveAuthenticatedLandingRedirect,
    resolveGuestMarketplaceInitRedirect,
} from '@/helpers/promo/session'
import { takeSpecialPaymentReturn } from '@/helpers/billing/specialPayment'
const { isNavigationFailure, NavigationFailureType } = VueRouter

Vue.use(VueRouter)
const routes = [
    {
        path: '/landing',
        name: 'Landing',
        component: Landing,
        unprotected: true,
    },
    {
        path: '/promo/:key',
        name: 'PromoResolve',
        component: () => import('../views/PromoResolve.vue'),
        unprotected: true,
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('../views/ResetPassword.vue'),
        unprotected: true,
    },
    {
        path: '/qr/:connectorId',
        name: 'QrCodePage',
        component: () => import('@/components/connectors/whatsappBasis/QrCodePage.vue'),
        unprotected: true,
    },
    {
        path: '/projects',
        name: 'Projects',
        component: Projects,
    },
    {
        path: '/project/:id',
        name: 'Project',
        component: Project,
    },
    {
        path: '/project/:id/settings',
        name: 'ProjectSettings',
        component: ProjectSettings,
    },
    {
        path: '/project/:id/settings/roles',
        name: 'RolesSettings',
        component: RolesSettings,
    },
    {
        path: '/OAuthLogin',
        name: 'OAuthLogin',
        component: OAuthLogin,
    },
    {
        path: '/project/:id/addConnectorStage1',
        name: 'AddConnectorStage1',
        component: AddConnectorStage1,
    },
    {
        path: '/project/:id/addChannelStage1',
        name: 'AddChannelStage1',
        component: AddChannelStage1,
    },
    {
        path: '/project/:id/addChannelStage2',
        name: 'AddChannelStage2',
        component: AddChannelStage2,
    },
    {
        path: '/project/:id/addChannelStage3',
        name: 'AddChannelStage3',
        component: AddChannelStage3,
    },
    {
        path: '/project/:id/addConnectorStage2',
        name: 'addConnectorStage2',
        component: AddConnectorStage2,
    },
    {
        path: '/project/:id/addConnectorStage3',
        name: 'addConnectorStage3',
        component: AddConnectorStage3,
    },
    {
        path: '/project/:id/connectorSettings/:connectorId',
        name: 'addConnectorStage3',
        component: ConnectorSettings,
    },
    {
        path: '/project/:id/scheduledReport',
        name: 'addScheduledReport',
        component: ScheduledReport,
    },
    {
        path: '/onBoarding',
        name: 'OnBoardingCreateProject',
        component: OnBoarding,
    },
    {
        path: '/project/:id/onBoarding',
        name: 'SelectCRMSystem',
        component: OnBoarding,
    },
    {
        path: '/project/:id/sendingSchemes',
        name: 'SendingSchemes',
        component: () => import('@/views/SendingSchemes.vue'),
    },
]
    .concat(GCB2Routes)
    .concat(adminRoutes)
    .concat(externalMarketplaceModuleRoutes)
    .concat(adminReportPseudActivationReportRoutes)
    .concat(staffTurnoverRoutes)
    .concat(staffTrajectoryRoutes)
    .concat(marketplaceModuleRoutes)
    .concat(beautyAutopilotRoutes)
    .concat(starterPackRoutes)
    .concat([{ path: '*', component: NotFound }])

export const unprotectedRoutesNames = routes.filter(el => el.unprotected).map(el => el.name)

//убирает ошибку Avoided redundant navigation to current location:
const routerPush = VueRouter.prototype.push
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => {
        if ((isNavigationFailure, NavigationFailureType.redirected)) {
            return
        }
        console.log('error.name', error.name)
        if (error.name !== 'NavigationDuplicated') {
            console.error(error)
        }
    })
}
VueRouter.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => {
        if ((isNavigationFailure, NavigationFailureType.redirected)) {
            return
        }
        console.log('error.name', error.name)
        if (error.name !== 'NavigationDuplicated') {
            console.error(error)
        }
    })
}
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
})

const waitForProjectsLoaded = () =>
    new Promise((resolve) => {
        if (!store.state.isProjectsLoading) {
            resolve()
            return
        }
        const unwatch = store.watch(
            state => state.isProjectsLoading,
            (projectsLoading) => {
                if (!projectsLoading) {
                    unwatch()
                    resolve()
                }
            }
        )
    })

const waitForAuthReady = (authInstance) =>
    new Promise((resolve) => {
        if (!authInstance.loading) {
            resolve()
            return
        }
        const unwatch = authInstance.$watch('loading', (loading) => {
            if (!loading) {
                unwatch()
                resolve()
            }
        })
    })

router.beforeEach(async (to, from, next) => {
    const billingWithoutSlash = to.path.match(/^\/project\/([^/]+)\/billing$/)
    if (billingWithoutSlash && to.name !== 'Billing') {
        next({
            path: `/project/${billingWithoutSlash[1]}/billing/`,
            query: to.query,
            hash: to.hash,
            replace: true,
        })
        return
    }

    // Блокируем уход со страницы во время создания канала / сохранения приоритетов
    // (разрешаем менять только query на том же path, т.к. это используется внутри сайдбара)
    const isChannelCreationLocked =
        !!store.state.channelCreationMode && (store.state.channelCreationLockCount || 0) > 0
    if (isChannelCreationLocked && to.path !== from.path) {
        try {
            store.dispatch('callNotify', 'Дождитесь завершения создания канала и установки приоритетов')
        } catch (e) {
            // ignore
        }
        next(false)
        return
    }
    if (to.params.id) {
        Sentry.setTag('projectId', to.params.id)
    } else {
        Sentry.setTag('projectId', null)
    }
    let nextCalled = false
    const safeNext = (arg) => {
        if (nextCalled) return
        nextCalled = true
        next(arg)
    }
    const route = routes.find(el => el.name === to.name)
    if (route?.requiresYClients) {
        await waitForProjectsLoaded()
        if (!hasYClientsConnector(store.getters.projectById(to.params.id))) {
            safeNext({ path: `/project/${to.params.id}`, replace: true })
            return
        }
    }
    if (route?.requiresBusinessPulseReport) {
        await waitForProjectsLoaded()
        const project = store.getters.projectById(to.params.id)
        const connector = project?.connectors?.find(connector => connector.connectorType === 'GCB2')
        // Покупка не закрывает маршрут: страница показывает экран подключения.
        // Отключённый коннектор GCB2 по-прежнему не пускает в отчёт.
        if (connector?.disabled) {
            safeNext({ path: `/project/${to.params.id}`, replace: true })
            return
        }
    }
    if (route && route.requiredRoles) {
        await waitForProjectsLoaded()
        const projectId = to.params.id
        if (!route.requiredRoles.every(role => checkRole(projectId, role))) {
            safeNext(from)
            return
        }
    }

    // TODO: отрефакторить авторизацию
    const authInstance = getInstance()
    await waitForAuthReady(authInstance)

    // Оплата заказа по ссылке без входа: токен ссылки проверяет backend. Без токена — как раньше, через вход.
    if (!authInstance.isAuthenticated && to.name === 'SpecialPayment' && to.query.t) {
        safeNext()
        return
    }
    // После ЮKassa плательщик по ссылке попадает в биллинг проекта, куда у него нет доступа, —
    // возвращаем его на страницу оплаты.
    if (to.name === 'Billing' && to.query.id) {
        const link = takeSpecialPaymentReturn(String(to.params.id || ''), Number(to.query.id))
        if (link) {
            safeNext({
                path: `/project/${encodeURIComponent(link.projectId)}/payment/${link.paymentPayloadId}`,
                query: { t: link.token, returned: '1' },
                replace: true,
            })
            return
        }
    }

    const isPublicMarketplaceRoute =
        to.path === '/marketplace' || to.path.startsWith('/marketplace/integration/')

    // Публичные страницы без авторизации: QR, маркетплейс
    if (to.path.startsWith('/qr/') || isPublicMarketplaceRoute) {
        safeNext()
        return
    }

    // Гостю — project-маркетплейс недоступен, открываем публичный (до редиректа на landing)
    if (!authInstance.isAuthenticated && to.path.includes('/marketplace')) {
        const integrationMatch = to.path.match(
            /^\/project\/[^/]+\/marketplace\/integration\/([^/]+)/
        )
        if (integrationMatch) {
            safeNext({
                path: `/marketplace/integration/${integrationMatch[1]}`,
                replace: true,
                query: to.query,
            })
            return
        }
        if (/^\/project\/[^/]+\/marketplace\/?$/.test(to.path)) {
            safeNext({ path: '/marketplace', replace: true, query: to.query })
            return
        }
    }

    const guestMarketplaceInitPath = !authInstance.isAuthenticated
        ? resolveGuestMarketplaceInitRedirect(to.query)
        : null
    if (
        guestMarketplaceInitPath &&
        (to.path === '/' || to.path === '/landing' || to.path === '/reset-password')
    ) {
        safeNext(guestMarketplaceInitPath)
        return
    }

    if (!authInstance.isAuthenticated && !unprotectedRoutesNames.includes(to.name) && !to.query.to) {
        const needsReturnPath = to.name === 'SpecialPayment'
        const nextPath = qs.stringifyUrl({
            url: '/landing',
            query: needsReturnPath
                ? Object.assign({}, to.query, { to: to.fullPath })
                : to.query,
        })
        safeNext(nextPath)
    } else if (
        authInstance.isAuthenticated &&
        (to.path === '/landing' || to.path === '/' || to.path === '/reset-password')
    ) {
        safeNext(resolveAuthenticatedLandingRedirect(to.query))
    } else if (authInstance.isAuthenticated && to.path.includes('/GetClientsBack')) {
        const projectId = to.params.id
        const nextPath = qs.stringifyUrl({
            url: `/project/${projectId}/GCB2`,
        })
        safeNext(nextPath)
    } else {
        safeNext()
    }
})

// Выход из Мультичата ловим здесь, а не вотчером во вьюхе: при уходе с роута GCB2
// компонент уничтожается раньше, чем успевает сработать его watch на $route,
// и выходы в Маркетплейс/на главную/в тарифы терялись. afterEach срабатывает
// только на состоявшейся навигации, поэтому заблокированные переходы не считаются.
router.afterEach((to, from) => {
    if (isChatSectionPath(from.fullPath) && !isChatSectionPath(to.fullPath)) {
        trackMultichatExit(to.fullPath)
    }
})

export default router
